module.exports = __webpack_public_path__ + "static/media/heattherm.8582ae50.pdf";